module.exports = __webpack_public_path__ + "img/notification-emoji.85f3a997.svg";